import {APIService} from '@/services/api.service';
import {Activity, Location, CandidateTransportationItem, getTimezoneOffset} from '@mobi-components/global-solution';

export interface IGetAlternativesRequest {
  sessionId: string;
  solutionId: string;
  activityId: string;
  problemId: string;
}
export interface IGetAlternativesResponse {
  results: Activity[];
  alternatives: Activity[];
  locations: Location[];
}

export enum SelectOptions {
  best_match = 'best_match',
  price_high = 'price_high',
  price_low = 'price_low',
  rating_high = 'rating_high',
}

export const SelectValueText: Record<SelectOptions, string> = {
  [SelectOptions.best_match]: 'Best match',
  [SelectOptions.price_high]: 'Price (High to Low)',
  [SelectOptions.price_low]: 'Price (Low to High)',
  [SelectOptions.rating_high]: 'Rating',
};

export async function loadAlternatives(
  payload: IGetAlternativesRequest,
  sort = SelectOptions.best_match,
): Promise<IGetAlternativesResponse | null> {
  try {
    const resp = await APIService.get<IGetAlternativesResponse>(`alternative-activity`, {
      params: {
        session_id: payload.sessionId,
        problem_id: payload.problemId,
        solution_id: payload.solutionId,
        activity_id: payload.activityId,
        max_number: 10,
        sort,
      },
    });

    return {
      ...resp,
      alternatives: resp.alternatives.map((x) => {
        const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const myTzOffsetMins = new Date().getTimezoneOffset();
        const startLocation =
          (x.source?.content as CandidateTransportationItem)?.origin ||
          resp.locations.find((y) => y.id === x.start_location);
        const endLocation =
          (x.source?.content as CandidateTransportationItem)?.destination ||
          resp.locations.find((y) => y.id === x.end_location);
        const source = x.source?.content as CandidateTransportationItem;
        const startTimezoneOffset =
          Math.round(getTimezoneOffset(new Date(), startLocation?.time_zone || localTimeZone)) - myTzOffsetMins;
        const endTimezoneOffset =
          Math.round(getTimezoneOffset(new Date(), endLocation?.time_zone || localTimeZone)) - myTzOffsetMins;

        const startTime = x.scheduled_start_time || source?.departure_timestamp || 0;
        const endTime = x.scheduled_end_time || source?.arrival_timestamp || 0;

        return {
          ...x,
          scheduled_start_time: startTime - startTimezoneOffset * 60,
          scheduled_end_time: endTime - endTimezoneOffset * 60,
        };
      }),
    };
  } catch (e) {
    return null;
  }
}
